// Extra request headers for services exposed through an ngrok tunnel.
//
// ngrok's free tier answers the first browser request to a tunnel with an
// HTML interstitial ("You are about to visit ...", ERR_NGROK_6024) instead of
// proxying it, so JSON fetches (translations, RTK Query, axios, the Flagsmith
// SDK) break when a service is exposed through ngrok. Sending
// `ngrok-skip-browser-warning` with any value bypasses that page. The header is
// only added when the URL is actually an ngrok tunnel so other environments
// keep their request shape (no extra CORS preflight).
const NGROK_HOST = /\.ngrok(-free)?\.(app|dev|io)(\/|:|$)/;

/** `ngrok-skip-browser-warning` when `url` is an ngrok tunnel, otherwise nothing. */
export const ngrokExtraHeaders = (url: string | undefined): Record<string, string> =>
	NGROK_HOST.test(url ?? "") ? { "ngrok-skip-browser-warning": "1" } : {};

/** Headers every call to REACT_APP_SERVER_URL must carry. */
export const serverExtraHeaders: Record<string, string> = ngrokExtraHeaders(
	process.env.REACT_APP_SERVER_URL,
);

export const applyServerExtraHeaders = (headers: Headers): Headers => {
	Object.entries(serverExtraHeaders).forEach(([name, value]) => headers.set(name, value));
	return headers;
};
